'use client'

import { ampli } from '@src/ampli-web'
import { useLocale } from '@src/i18n/LocaleProvider'
import { useTrackSelectCta } from '@src/utils/analytics.util'

import { LocalizedLink } from '../LocalizedLink/LocalizedLink'

interface BigFooterColumnProps {
  title: string
  items: Column[]
}

interface Column {
  text: string
  href?: string
  action?: string
  showOnlyInUS?: boolean
}

interface CustomWindow extends Window {
  Osano: any
}
declare let window: CustomWindow

function showOsanoDrawer() {
  if (!window?.Osano) return
  window?.Osano.cm.showDrawer()
}

function LinkOrAction({ item }: { item: Column }) {
  const trackSelectCta = useTrackSelectCta()
  if (item.action === 'showOsanoDrawer') {
    return (
      <div className="cursor-pointer hover:underline">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href=""
          onClick={(e) => {
            e.preventDefault()
            showOsanoDrawer()
          }}
        >
          {item.text}
        </a>
      </div>
    )
  }
  return (
    <LocalizedLink
      href={item.href ?? ''}
      className="hover:underline"
      onClick={() => {
        trackSelectCta({ 'cta url': item.href })
        ampli.flush()
      }}
    >
      {item.text}
    </LocalizedLink>
  )
}

export const BigFooterColumn = (props: BigFooterColumnProps) => {
  const { items, title } = props
  const { locale } = useLocale()
  const isLocaleUSEnglish = locale.code === 'en-US'

  return (
    <div className="text-body-sm" key={title}>
      <h6 className="mb-3 font-medium">{title}</h6>
      <div className="flex flex-col items-start gap-0.5">
        {items?.map((item, index) => {
          const { showOnlyInUS } = item
          if (showOnlyInUS && !isLocaleUSEnglish) return null
          return <LinkOrAction item={item} key={`${item.href}-${index}`} />
        })}
      </div>
    </div>
  )
}
